import 'stylesheets/components/licensePlates.scss';
import 'stylesheets/components/page.scss';
import 'stylesheets/global.scss';

import React, {PropTypes} from 'react';
import {reduxForm, getValues} from 'redux-form';
import {connect} from 'react-redux';
import {injectIntl,intlShape} from 'react-intl';
import _ from 'lodash';

import resetForm from 'app/lib/resetForm';
import {displayToServerDate} from 'app/lib/format';
import PureRenderComponent from 'app/lib/PureRenderComponent';
import {Select, Input, Button, Row, Col, Toast} from 'routes/app/components';
import VisitFilterForm from '../components/VisitFilterForm';
import {getPackagingUnity,getUnitKinds,getTerminals,getVisitIds,getOwnerTransporterId,
    getLicensePlates,getExecutingTransportCompanies, getDocTypes, getUnitStates} from 'modules/profile/selectors';

class VisitFilter extends PureRenderComponent {

    static propTypes = {
        fields: PropTypes.object.isRequired,
        getVisits: PropTypes.func.isRequired,
        licensePlate: PropTypes.string,
        licensePlates: PropTypes.array,
        transCompList: PropTypes.array,
        terminals: PropTypes.array,
        unitStates: PropTypes.array,
        handleSubmit: PropTypes.func.isRequired,
        intl: intlShape
    };

    constructor(props) {
        super(props);
        this.state = {
            filterExpanded: false
        };
    }

    buildSelectDataFrom(arr, val, label) {
        arr = arr || [];
        if (!val) {
            return [this.props.intl.formatMessage({id:'select.any'})].concat(arr);
        } else {
            return [{
                [val]: '',
                [label]: this.props.intl.formatMessage({id:'select.any'})
            }].concat(arr);
        }
    }

    toggleFilterExpanded = () => {
        this.setState({
            filterExpanded: !this.state.filterExpanded
        });
    };

    resetForm = () => {
        resetForm(this.props.fields);
        this.props.getVisits();
    };

    submitHandler = (data) => {
        if (data.from) {
            data.from = displayToServerDate(data.from);
        }
        if (data.to) {
            data.to = displayToServerDate(data.to);
        }
        this.props.getVisits({filters:_.omitBy(data, value => !value)});
    };

    render() {
        const {terminals, fields, licensePlates, unitStates, handleSubmit, transCompList, intl:{formatMessage}} = this.props;
        let highlight = false;
        if (!this.state.filterExpanded) {
            _.each(fields, (field) => {
                if (field.value) {
                    highlight = true;
                }
            });
        }

        return (
            <VisitFilterForm
                onClickFilter={this.toggleFilterExpanded}
                expanded={this.state.filterExpanded}
                licensePlates={licensePlates}
                statuses={this.buildSelectDataFrom(unitStates, 'code', 'display')}
                fields={fields}
                onSubmit={handleSubmit(this.submitHandler)}
                resetForm={this.resetForm}
                transCompList={this.buildSelectDataFrom(transCompList, 'code', 'name')}
                terminals={this.buildSelectDataFrom(terminals, 'code', 'name')}
                formatMessage={formatMessage}
                highlight={highlight}
            />
        );
    }

}


function mapStateToProps(state) {
    return {
        terminals: getTerminals(state),
        licensePlates: getLicensePlates(state),
        unitStates: getUnitStates(state),
        transCompList: getExecutingTransportCompanies(state),
        initialValues: {
            licensePlate: state.get('profile').get('licensePlate')
        }
    };
}

export default reduxForm({
        form: 'visitFilter',
        fields: ['lp', 'status', 'dom', 'trac', 'vn', 'tc', 'from', 'to'],
        getFormState: (state, reduxMountPoint) => state.get(reduxMountPoint).toJS()
    },
    mapStateToProps
)(injectIntl(VisitFilter));
